import { memo } from "react";

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

import ServiceConnectionStep from "components/ServiceConnectionStep";

// -----------------------------------------------------------------------------

const VerifyingAPITokenPhase = memo(function VerifyingAPITokenPhase({
  disabled,
  organization,
  progressIcon,
  successIcon,
  errorIcon,
}: ConfiguringCloudTrailPhaseProps): JSX.Element {
  return (
    <ServiceConnectionStep disabled={disabled}>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {progressIcon ? <CircularProgress size="24px" sx={{ mr: 1 }} /> : null}
        {successIcon ? (
          <CheckCircleOutlineRoundedIcon color="success" sx={{ mr: 1 }} />
        ) : null}
        {errorIcon ? (
          <ErrorOutlineRoundedIcon color="error" sx={{ mr: 1 }} />
        ) : null}
        <Typography variant="body1">
          Connecting{" "}
          <strong>{organization || "https://your-org-here.okta.com"}</strong>.
          Verifying API token...
        </Typography>
      </Box>
      <Box sx={{ mt: 2 }}>
        <Typography variant="body1">
          We check that the Okta API token and organization you provided
          actually works!
        </Typography>
      </Box>
    </ServiceConnectionStep>
  );
});

export default VerifyingAPITokenPhase;

// -----------------------------------------------------------------------------

interface ConfiguringCloudTrailPhaseProps {
  disabled: boolean;
  organization: string;
  progressIcon: boolean;
  successIcon: boolean;
  errorIcon: boolean;
}
